import { fetchRequestWithTypes } from './index.js';

export const GET_DYNAMIC_PLANS_REQUEST = 'GET_DYNAMIC_PLANS_REQUEST';
export const GET_DYNAMIC_PLANS_SUCCESS = 'GET_DYNAMIC_PLANS_SUCCESS';
export const GET_DYNAMIC_PLANS_ERRORED = 'GET_DYNAMIC_PLANS_ERRORED';

export const getDynamicPlans = () => {
	return fetchRequestWithTypes({
		types: [
			GET_DYNAMIC_PLANS_REQUEST,
			GET_DYNAMIC_PLANS_SUCCESS,
			GET_DYNAMIC_PLANS_ERRORED,
		],
		request: {
			method: 'GET',
			path: `/customers/v1/subscriptions/plans`,
		},
	});
};

export const POST_USER_PLAN_REQUEST = 'POST_USER_PLAN_REQUEST';
export const POST_USER_PLAN_SUCCESS = 'POST_USER_PLAN_SUCCESS';
export const POST_USER_PLAN_ERRORED = 'POST_USER_PLAN_ERRORED';

export const postUserPlan = (body) => {
	return fetchRequestWithTypes({
		types: [POST_USER_PLAN_REQUEST, POST_USER_PLAN_SUCCESS, POST_USER_PLAN_ERRORED],
		request: {
			method: 'POST',
			path: '/customers/v1/subscriptions',
			body,
		},
	});
};
